import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from './http.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { CurrentUser } from '../common/currentuser.model';
import { MainStore } from '../common/main.store';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(
    private http: HttpService,
    private store: MainStore,
  ) { }

  // CRUD methods
  async GetCurrentUserInfo(): Promise<CurrentUser> {
    return await this.http.get<CurrentUser>(`${environment.adminConfig.apiUri}/user/current`);
  }

  async getUserInfo(): Promise<boolean> {
    const data = await this.GetCurrentUserInfo()
    if (data) {
      this.store.currentUser.set(data);
      return true;
    } else {
      return false;
    }      
  }
}

